import { defineComponent } from 'vue';
import { useStoreWechat } from '@src/store/modules/wechat';
import { Button } from 'ant-design-vue';
import { getImageUrl } from '@/utils';
import SvgIcon from '@src/components/SvgIcon';

export default defineComponent({
    name: 'WechatQrcode',
    emits: ['setKey'],
    setup(props, context) {
        const storeWechat = useStoreWechat();
        storeWechat.getWechatQrcode();

        watch(
            () => storeWechat.isBindPhone,
            val => {
                if (!val) context.emit('setKey', '手机号绑定'); // 未绑定手机号、则切换到手机号绑定
            }
        );

        onBeforeUnmount(() => {
            storeWechat.clearPollTimer();
            storeWechat.clearExpiredTimer();
        });

        return () => (
            <div class='wechat-qrcode g-flex g-flex-col g-items-center'>
                <div class='wechat-qrcode-header'>微信扫码安全登录</div>
                <div class='wechat-qrcode-content g-flex g-flex-col g-items-center'>
                    <div class='content-main g-relative'>
                        {storeWechat.imageBase ? <img class='g-flex-shrink-0' src={storeWechat.imageBase} /> : null}
                        {storeWechat.isExpired ? (
                            <div
                                onClick={storeWechat.getWechatQrcode}
                                class='content-main-expired g-absolute g-left-[0] g-top-[0] g-h-full g-w-full g-flex g-flex-col g-items-center g-justify-center g-bg-black/[0.4]'
                            >
                                <img class='g-h-[36px] g-w-[36px] g-cursor-pointer' src={getImageUrl('images/login-reload-qrcode.png')} />
                            </div>
                        ) : null}
                    </div>
                    <span>使用微信扫一扫登录</span>
                </div>
                <div class='wechat-qrcode-footer g-w-full g-flex g-flex-col g-items-center'>
                    <span class='text-divider g-w-full g-flex g-items-center g-justify-between'>其它登录方式</span>
                    <Button
                        type='primary'
                        class='g-flex g-items-center'
                        onClick={() => {
                            context.emit('setKey', '账号密码登录');
                        }}
                        ghost
                    >
                        <SvgIcon name='phone' />
                        账号密码登录
                    </Button>
                </div>
            </div>
        );
    },
});
